import { observer } from 'mobx-react-lite'
import { PayoutSplitAllocatorContainer } from '@/features/jobs/details/components/PayoutSplitAllocator/PayoutSplitAllocatorContainer'
import { TotalAllocatedStatusContainer } from '@/features/jobs/details/components/PayoutSplitAllocator/TotalAllocatedStatus/TotalAllocatedStatusContainer'
import { AddAllocationButtonContainer } from '@/features/jobs/details/components/PayoutSplitAllocator/AddAllocationButton/AddAllocationButtonContainer'
import { SplitPayoutDialog } from '@/features/jobs/details/components/SplitPayoutDialog'
import { type SplitPayoutDialogViewModel } from './SplitPayoutDialogViewModel'

export interface SplitPayoutDialogContainerProps {
  vm: SplitPayoutDialogViewModel
}

export const SplitPayoutDialogContainer = observer(
  function SplitPayoutDialogContainer({ vm }: SplitPayoutDialogContainerProps) {
    return (
      <SplitPayoutDialog
        showing={vm.modal.showing}
        situation={vm.situation}
        payoutTotal={vm.allocatorVm.payoutTotal}
        allocator={<PayoutSplitAllocatorContainer vm={vm.allocatorVm} />}
        totalAllocatedStatus={
          <TotalAllocatedStatusContainer vm={vm.allocatorVm} />
        }
        addAllocationButton={
          <AddAllocationButtonContainer vm={vm.allocatorVm} />
        }
        splitPayoutError={vm.splitPayout.error}
        isSplitPayoutPending={vm.splitPayout.pending}
        isSplitValid={vm.allocatorVm.isSplitValid}
        onClose={vm.modal.close}
        onSplitPayout={vm.splitPayout}
      />
    )
  },
)
